import RightArrowSvg from "../../Atoms/RightArrowSvg/RightArrowSvg";
import "./RegularCard.scss";
import { Link } from "wouter";

function RegularCard({ img, title, content, section, linkText, linkHref }) {
	return (
		<div className={`regular-card-container ${section}`}>
			<img src={img} alt="img" className="regular-card-img" />
			<div className="regular-card-content">
				<h1
					className={`t4 center-text pr-20 pl-20 regular-card-text-align ${section} ${
						section && "pl-30"
					}`}
				>
					{title}
				</h1>
				<p
					className={`body18 pr-30 pl-30 center-text regular-card-text-align ${section}`}
				>
					{content}
				</p>
				{linkText && section !== "tutorials" && (
					<Link href={linkHref ? linkHref : ""}>
						<div className="regular-card--link-container">
							<p
								className={`c-light-blue pr-30 pl-30 regular-card-text-align regular-card-link-text ${section}`}
							>
								{linkText}
							</p>
							<div className="regular-card--svg-container">
								<RightArrowSvg />
							</div>
						</div>
					</Link>
				)}
				{linkText && section === "tutorials" && (
					<p
						className={`c-light-blue pr-30 pl-30 regular-card-text-align regular-card-link-text ${section}`}
					>
						{linkText}
					</p>
				)}
			</div>
		</div>
	);
}

export default RegularCard;
